import { blue, green, red } from "@/theme/theme-primitives";
import styled from "@emotion/styled";

export const UploadContainer = styled.div`
  border: 2px dashed ${(props) => (props.isDragging ? blue[500] : blue[200])};
  border-radius: 0.5rem;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${(props) =>
    props.isDragging ? "rgba(59, 130, 246, 0.05)" : "transparent"};
  width: 100%;

  &:hover {
    border-color: ${(props) => blue[400]};
    background-color: rgba(59, 130, 246, 0.05);
  }
`;

export const UploadContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: grey;
`;

export const UploadIcon = styled.div`
  color: ${(props) => green[500]};
`;

export const UploadText = styled.p`
  margin: 0;
  font-size: 1rem;
`;

export const UploadCounter = styled.span`
  font-size: 14px;
  color: ${(props) => green[500]};
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
`;

export const ImageContainer = styled.div`
  position: relative;
  aspect-ratio: 1;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const RemoveButton = styled.button`
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  background-color: rgba(255, 255, 255, 0.7);
  color: ${(props) => red[500]};
  border: none;
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
  padding: 0;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) => green[500]};
    transform: scale(1.1);
  }
`;
